import { BillboardButton, Row } from '@fs/zion-ui'
import { ContentAdd } from '@fs/zion-icon'
import React from 'react'

export default function AddInputButton({ setter, fieldId, testId, label, fieldType, name, buttonText }) {
  return (
    <Row>
      <BillboardButton
        data-testid={`add-${testId}`}
        Icon={ContentAdd}
        color="blue"
        emphasis="low"
        onClick={() =>
          setter({
            id: fieldId,
            label,
            fieldType,
            name,
            elementType: 'FIELD',
          })
        }
      >
        {buttonText}
      </BillboardButton>
    </Row>
  )
}
